import axios from "axios";
import { Component } from "react";
import { v4 as uuidv4 } from 'uuid';
import { getFormattedAccessGroup, LocationOrigin } from "./utilityServices";
import Cookies from "universal-cookie";
import { Authentication } from './authenticationUtilityServices';
const _cookies = new Cookies();
export default class Services extends Component {
    getService = async (data, dbquery) => {
        let res;
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(
            `${LocationOrigin}${process.env.REACT_APP_IMS_API_URL}?dbquery=${dbquery}`,
            {
                headers: _headers
            }
        ).then((response) => {
            res = response.data.rows
            //this.logService(`API call successful for dbquery:${dbquery}`,'info')
        }).catch((error) => {
            //console.log(error)
            this.logService(`API call failed for dbquery:${dbquery}`, 'error')
        })
        return res
    }
    getAllFilters = async (reqBody) => {
        let url = LocationOrigin + process.env.REACT_APP_IMS_QP_API + 'getAllFilters'
        let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'));
        reqBody.accessGroup = getFormattedAccessGroup(userAccessGroup);
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        let res
        var config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: reqBody
        };
        await axios(config)
            .then((response) => {
                res = response
            }).catch((error) => {
                //console.log('Error in get all Filters')
                this.logService(`API call error for getAllFilters: ${error}`, 'error')
            })
        return res;
    }
    getPubMedAllFilters = async () => {
        let url = LocationOrigin + process.env.REACT_APP_IMS_QP_API + 'runPubMedSearch?query=&filters=&from=0&size=0'
        let res
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        var config = {
            method: 'GET',
            url: url,
            headers: _headers
        };
        await axios(config)
            .then((response) => {
                res = response
            }).catch((error) => {
                //console.log('Error in get all Filters')
                this.logService(`API call error for getPubMedAllFilters: ${error}`, 'error')
            })
        return res;
    }
    getJJEDSservice = async (userid) => {
        let res
        const _headers = {
            'Content-Type': 'application/json',
            'x-api-key': `${process.env.REACT_APP_IMS_API_KEY}`
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(
            LocationOrigin + process.env.REACT_APP_IMS_API_PREFIX + `jjeds/${userid}`,
            {
                headers: _headers
            }
        ).then((response) => {
            //console.log(res.data)
            res = response.data
        }).catch((error) => {
            //console.log(error)
            this.logService(`API call error for jjeds: ${error}`, 'error')
        })
        return res;
    }
    getSuggestions = async (param) => {
        let res;
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(`${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}qp/getSuggestions?query=${param}`, {
            headers: _headers
        }).then((response) => {
            res = response
        }).catch((error) => {
            //console.log(error)
            this.logService(`API call error for suggestions: ${error}`, 'error')
        })
        return res;
    }
    getLimiDropdown = async (param) => {
        let res;
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(`${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}fs/${param}`, {
            headers: _headers
        }).then((response) => {
            res = response.data
        }).catch((error) => {
            this.logService(`API call error for ${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}fs/${param}: ${error}`, 'error')
        })
        return res;
    }
    postService = async (url, data) => {
        let res
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.post(url,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            }, {
            headers: _headers
        }
        ).then((response) => {
            res = response
        }).catch((error) => {
            //console.log(error);
            this.logService(`POST API call error for url: ${url}`, 'error')
        })
        return res
    }
    postServiceForDb = async (query) => {
        let res
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.post(LocationOrigin + process.env.REACT_APP_IMS_API_URL,
            {
                dbquery: query
            },
            {
                headers: _headers
            }
        ).then((response) => {
            res = response
        }).catch((error) => {
            //console.log(error);
            this.logService(`DB API failed for : ${query}`, 'error')
        })
        return res
    }
    putService = async (query) => {
        let res
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.put(LocationOrigin + process.env.REACT_APP_IMS_API_URL,
            {
                dbquery: query
            },
            {
                headers: _headers
            }
        ).then((response) => {
            res = response
        }).catch((error) => {
            //console.log(error)
            this.logService(`DB UPDATE API failed for : ${query}`, 'error')
        })
        return res
    }
    getkeywordQueryTransform = async (param) => {
        let res = [];
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        let req = { "verbatim_question": param }
        let url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_NLP_ANSWERS}ims_keyword_query_transform`;
        //url = `https://predev-ims.jnj.com/api/nlpanswers/ims_keyword_query_transform`;
        await axios.post(url, req, { headers: _headers }).then((response) => {
            res = response.data;
        }).catch((error) => {
            this.logService(`API call error for ${LocationOrigin}${process.env.REACT_APP_IMS_API_NLP_ANSWERS}ims_keyword_query_transform {verbatim_question=${param}}: ${error}`, 'error')
        })
        return res;
    }
    getSynonyms = async (param) => {
        let res = [];
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(`${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}fs/getsynonym?keyword=${param}`,
            {
                headers: _headers
            }).then((response) => {
                res = response.data;
            }).catch((error) => {
                this.logService(`API call error for ${LocationOrigin} ${process.env.REACT_APP_IMS_API_PREFIX}fs/getsynonym?keyword=${param}: ${error}`, 'error')
            })
        return res;
    }
    logServiceForLoginIssus = async (data) => {
        try {
            let url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}logger/logapi`
            let id = uuidv4();
            let sid = _cookies.get("sid");
            let isSidExpired = _cookies.get("isSidExpired");
            let logLocalStorage = { ...localStorage }
            logLocalStorage.displayedResults = "";
            logLocalStorage.AccessToken = "";
            logLocalStorage.RefreshToken = "";
            logLocalStorage.cookieSid = sid;
            logLocalStorage.cookieIsSidExpired = isSidExpired;
            logLocalStorage.data = data
            const _headers = {
                'Content-Type': 'application/json'
            };
            if (await Authentication.isAccessTokenAvailable()) {
                // No Authorization header provided, attach the default one
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            let req = {
                'id': `UI-id-${id}`,
                'service': 'User Interface',
                'message': data,// JSON.stringify(logLocalStorage),
                'log': 'info'
            }
            if (LocationOrigin !== "http://localhost:3000" && LocationOrigin !== 'https://predev-ims.jnj.com') {
                axios.post(url,
                    {
                        data: req
                    },
                    {
                        headers: _headers
                    }
                ).then((response) => {
                    //console.log(response);
                }).catch((error) => {
                    console.log(error);
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
    logService = async (data, logType) => {
        let url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}logger/logapi`
        let id = uuidv4();
        let req = {
            'id': `UI-id-${id}`,
            'service': 'User Interface',
            'message': data,
            'log': logType
        }
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        if (LocationOrigin !== "http://localhost:3000" && LocationOrigin !== 'https://predev-ims.jnj.com') {
            axios.post(url,
                {
                    data: req
                },
                {
                    headers: _headers
                }
            ).then((response) => {
                //console.log(response);
            }).catch((error) => {
                console.log(error);
            })
        }
    }
}
